'use strict';

angular.module('imagetrend.components')
    .controller('ApplicationResponse', ['$scope', '$stateParams', '$uibModal', '$q', '$rootScope', '$timeout', 'FBResponses', 'LicenseRequests', 'Triggers', '$state', '$filter', '$window', 'Session', 'SignalR',
        function ($scope, $stateParams, $uibModal, $q, $rootScope, $timeout, FBResponses, LicenseRequests, Triggers, $state, $filter, $window, Session, SignalR) {
            $scope.portal = $state.current.data.isPortal;
            $scope.saving = false;
            $scope.loading = true;
            $scope.progressing = false;
            $scope.completed = false;
            $scope.parameters = {};
            $scope.advance = false;
            $scope.timeouts = [];
            $scope.submitting = false;
            $scope.loadingMessage = '';

            $scope.vm = {
                api: {},
                formsApi: {}
            }
            Session.CheckSession().then(function (validSession) {
                if (validSession) {
                    Session.checkIn();
                    if ($stateParams.responseID != null) {
                        FBResponses.getByID($stateParams.responseID).then(function (response) {
                            if (response != null) {
                                if (response.progress == 2) {
                                    $scope.completed = true;
                                }
                                $scope.parameters = { response_id: $stateParams.responseID, license_request_id: response.license_request_id, license_id: response.license_id, user_id: response.user_id, service_id: response.service_id, vehicle_id: response.vehicle_id, child_service: response.child_service, default_license_category_id: response.license_category_id, display_changed_answers: response.form.display_changed_answers };

                                if ($scope.fireStartTrigger != null && $scope.fireStartTrigger == 'true' && response.progress == 0) {
                                    response.progress = 1;
                                    response.started_on = new Date();
                                    FBResponses.save(response, null, false);
                                    if (response.form.start_trigger_name != null && response.form.start_trigger_name != "") {
                                        Triggers.fire({
                                            name: response.form.start_trigger_name,
                                            triggerID: response.form.start_trigger_id,
                                            licenseRequestID: response.license_request_id
                                        });
                                    }
                                }

                                // Move on
                                $scope.setProgress(response);
                                $scope.response = response;
                                $scope.the_form = response.form.the_form;
                                $scope.loading = false;
                            }
                            else {
                                $scope.loading = false;
                                $scope.responseError = true;
                            }
                        });
                    }
                    else {
                        if ($scope.portal) {
                            if ($scope.review) {
                                $state.go('portal.menus.review');
                            }
                            else {
                                var newContinuePage = $rootScope.portal_pages["portal.menus.applicationsContinueList"];
                                if (newContinuePage != null && newContinuePage.visible) {
                                    $state.go('portal.menus.applicationsContinueList');
                                } else {
                                    $state.go('portal.menus.applications');
                                }
                            }
                        }
                        else {
                            $state.go('internal.licensing.application.responses', { id: $scope.applicationID });
                        }
                    }
                }
                else {
                    $state.go('portal.menus.denied');
                }
            });

            $scope.setProgress = function (response, submitRequest) {
                var d = $q.defer();
                if (typeof submitRequest === 'undefined') {
                    submitRequest = false;
                }
                // need the timeout so that the calculations of what pages have content finishes first
                var timer = $timeout(function () {
                    $scope.progressing = true;

                    if ($scope.completed) {
                        if (response.form.pages.length > 0) {
                            response.form.pages[0].tab_active = true;
                        }
                        $scope.progressing = false;
                        $scope.saving = false;
                    }
                    else {
                        var foundMatch = false;

                        // Loop through the pages and check to see if they have a response_page record. The first one that doesn't will be our active page, and any after will be disabled
                        if (response != null && response.form != null && response.form.pages != null) {
                            var activePage = $scope.vm.formsApi.activePage();
                            response.form.pages.forEach(function (page) {
                                page.disabled = foundMatch && !page.completed;
                                if (!page.completed && !foundMatch && page.has_content && $scope.advance == true) {
                                    page.tab_active = true;
                                    foundMatch = true;
                                }
                                else {
                                    if ($scope.advance == false) {
                                        page.tab_active = activePage && page.id == activePage.id;
                                        if (page.tab_active) {
                                            foundMatch = true;
                                        }
                                    }
                                    else {
                                        page.tab_active = false;
                                    }
                                }
                            });
                        }

                        if (!foundMatch && $scope.advance == true) {
                            for (var i = response.form.pages.length - 1; i >= 0; i--) {
                                var page = response.form.pages[i];

                                if (!foundMatch && page.has_content) {
                                    page.tab_active = true;
                                    foundMatch = true;
                                }
                                page.disabled = !foundMatch && !page.completed;
                            }
                        }

                        $scope.progressing = false;
                        if (submitRequest != true) {
                            $scope.saving = false;
                        }
                        $window.scrollTo(0, 0);
                        d.resolve();
                    }
                }, 0);
                $scope.$on('$destroy', function () {
                    $timeout.cancel(timer);
                });
                return d.promise;
            }

            $scope.showSave = function () {
                var currentPage = $scope.vm.formsApi.activePage();
                if (currentPage != null) {
                    return currentPage.show_save_button;
                }
                else {
                    return false;
                }
            }

            $scope.showSaveAndContinue = function () {
                return ($scope.vm.formsApi.activePageIndex() < $scope.vm.formsApi.pagesCount());
            }

            $scope.showSubmit = function () {
                return ($scope.vm.formsApi.activePageIndex() >= $scope.vm.formsApi.pagesCount());
            }

            // This function exists because after a save, the form coming back is fresh from the database, and we'll loose several "custom" properties that have been put on the form. And we want them still
            $scope.copyCustomResponseFields = function (response) {
                var d = $q.defer();
                // pages
                for (var i = 0; i < $scope.response.form.pages.length; i++) {
                    var page = $scope.response.form.pages[i];
                    // sections
                    for (var j = 0; j < page.sections.length; j++) {
                        var section = page.sections[j];
                        response.form.pages[i].sections[j].expanded = section.expanded;
                        //components
                        for (var k = 0; k < section.components.length; k++) {
                            var component = section.components[k];
                            if (component.elementAnswer !== undefined) {
                                response.form.pages[i].sections[j].components[k].elementAnswer = component.elementAnswer;
                            }
                            if (component.parameters !== undefined) {
                                response.form.pages[i].sections[j].components[k].parameters = component.parameters;
                            }
                            // groups
                            for (var l = 0; l < component.groups.length; l++) {
                                var group = component.groups[l];
                                if (group.edit != undefined) {
                                    response.form.pages[i].sections[j].components[k].groups[l].edit = group.edit;
                                }
                                if (group.parameters !== undefined) {
                                    response.form.pages[i].sections[j].components[k].groups[l].parameters = group.parameters;
                                }
                                // questions
                                for (var m = 0; m < group.questions.length; m++) {
                                    var question = group.questions[m];
                                    if (question.answer !== undefined && question.answer != null) {
                                        response.form.pages[i].sections[j].components[k].groups[l].questions[m].answer.invalid = question.answer.invalid;
                                        if (question.answer.document_description !== undefined && question.answer.document_description != null) {
                                            response.form.pages[i].sections[j].components[k].groups[l].questions[m].answer.document_description = question.answer.document_description;
                                        }
                                        if (question.answer.document_name !== undefined && question.answer.document_name != null) {
                                            response.form.pages[i].sections[j].components[k].groups[l].questions[m].answer.document_name = question.answer.document_name;
                                        }
                                        if (question.answer.document_type !== undefined && question.answer.document_type != null) {
                                            response.form.pages[i].sections[j].components[k].groups[l].questions[m].answer.document_type = question.answer.document_type;
                                        }
                                        if (question.validation !== undefined && question.validation != null) {
                                            response.form.pages[i].sections[j].components[k].groups[l].questions[m].validation = question.validation;
                                        }
                                    }
                                    // sub components
                                    for (var n = 0; n < question.sub_components.length; n++) {
                                        var subcomponent = question.sub_components[n];
                                        if (subcomponent.parameters !== undefined) {
                                            //make sure subcomponent is defined before parameters are set to it, else
                                            //TypeError: Cannot set property 'parameters' of undefined
                                            //this may have to be the structure throughout this function if we get other TypeErrors in the console
                                            response.form.pages[i].sections[j].components[k].groups[l].questions[m].sub_components[n] = subcomponent;
                                            response.form.pages[i].sections[j].components[k].groups[l].questions[m].sub_components[n].parameters = subcomponent.parameters;
                                        }
                                        // groups
                                        for (var o = 0; o < subcomponent.groups.length; o++) {
                                            var subgroup = subcomponent.groups[o];
                                            if (subgroup.parameters !== undefined) {
                                                response.form.pages[i].sections[j].components[k].groups[l].questions[m].sub_components[n].groups[o].parameters = subgroup.parameters;
                                            }
                                            for (var p = 0; p < subgroup.questions.length; p++) {
                                                var subquestion = subgroup.questions[p];
                                                if (subquestion.answer !== undefined && subquestion.answer != null) {
                                                    response.form.pages[i].sections[j].components[k].groups[l].questions[m].sub_components[n].groups[o].questions[p].answer.invalid = subquestion.answer.invalid;
                                                }
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
                d.resolve();
                return d.promise;
            }

            // Make the tab clicked the only active tab
            $scope.switchActiveTab = function (pages, tab) {
                // remove active classes
                pages.forEach(function (page) {
                    if (page.id !== tab.id) {
                        page.tab_active = false;
                        var li = document.getElementById(page.id);
                        if (li) {
                            li.classList.remove('active');
                        }
                    }
                });

                // add active class to the clicked tab
                setTimeout(function () {
                    tab.tab_active = true;
                    var li = document.getElementById(tab.id);
                    var liField = document.getElementById("fieldset_" + tab.id);
                    var liFieldPar = (liField) ? liField.parentElement : null;
                    if (li) {
                        li.classList.add('active');
                    }
                    if (liFieldPar) {
                        liFieldPar.classList.add('active');
                    }
                }, 0);
            }

            $scope.save = function (advance, submitRequest) {
                var deferred = $q.defer();
                Session.checkIn();
                $scope.loadingMessage = "Saving application response...";
                $scope.saving = true;
                $scope.answerRefresh = false;
                $scope.advance = advance == true;

                FBResponses.saveByForm($scope.response, $scope.applicationID, $scope.vm.formsApi.absoluteFurthestPageIndex(), false, false, false).then(function (response) {
                    if (response != null && response.documentErrors != null && response.documentErrors.length > 0) {
                        deferred.resolve(response.documentErrors);
                    }
                    else if (response != null && response.signatureError) {
                        deferred.resolve(response.signatureError);
                    }
                    else {
                        deferred.resolve();
                    }

                    if (response != null && response.documentErrors != null && response.documentErrors.length > 0) {
                        //Something errored when saving documents - display modal, and don't advance or set progress
                        var documentNames = response.documentErrors.map(function (error) { return "<li>" + error.document_name + "</li>"; }).join('');
                        $scope.saving = false;
                        $uibModal.open({
                            animation: true,
                            templateUrl: 'templates/alert-modal/alert-modal.html',
                            controller: 'AlertModalController',
                            resolve: {
                                message: function () {
                                    if ($scope.portal) {
                                        return "Form has been saved, but an error occurred uploading the following document"
                                            + (response.documentErrors.length > 1 ? "s" : "")
                                            + ":<br/><ul style='margin-top: 10px'>"
                                            + documentNames
                                            + "</ul>Please try again. If you continue to experience problems, please contact your system administrator.";

                                    }
                                    else {
                                        return "Form has been saved, but an error occurred uploading the following document"
                                            + (response.documentErrors.length > 1 ? "s" : "")
                                            + ":<br/><ul style='margin-top: 10px'>"
                                            + documentNames
                                            + "</ul>Please try again. If you continue to experience problems, please submit a support ticket.";
                                    }
                                }
                            }
                        })
                    }
                    else if (response != null && response.signatureError) {
                        // signature required but missing
                        $scope.saving = false;
                        $uibModal.open({
                            animation: true,
                            templateUrl: 'templates/alert-modal/alert-modal.html',
                            controller: 'AlertModalController',
                            resolve: {
                                message: function () {
                                    return response.signatureError;
                                }
                            }
                        })
                    }
                    else if (response != null) {
                        response.form.the_form = $scope.response.form.the_form;
                        response.form.setupValidationMessages = $scope.response.form.setupValidationMessages;
                        if (response.form.pages != null) {
                            $filter('filter')(response.form.pages, $scope.vm.formsApi.hasContent());
                        }
                        var a = $scope.setProgress(response, submitRequest);
                        var b = $scope.copyCustomResponseFields(response);
                        $q.all([a, b]).then(function () {
                            if (submitRequest !== true) { $scope.response = response; }
                            $scope.answerRefresh = true;
                            $scope.$evalAsync(function () {
                                if ($scope.response.form.setupValidationMessages != null && $scope.response.form.setupValidationMessages !== undefined) {
                                    $scope.response.form.setupValidationMessages($scope.response.form);
                                }
                            });
                            if ($scope.advance == true) {
                                $scope.vm.api.doRecalculate();
                                $scope.vm.api.scrollTabIntoView();

                                // Help switch active tab after doRecalculate()
                                if (response.form.pages != null) {
                                    for (var i = 0; i < $scope.response.form.pages.length; i++) {
                                        if ($scope.response.form.pages[i].tab_active === true) {
                                            $scope.switchActiveTab($scope.response.form.pages, $scope.response.form.pages[i]);
                                            break;
                                        }
                                    }
                                }
                            }
                        })
                        .catch(function (response) {
                            // handle error
                        });
                    }
                    else {
                        // something errored in the .NET side
                        $uibModal.open({
                            animation: true,
                            templateUrl: 'templates/alert-modal/alert-modal.html',
                            controller: 'AlertModalController',
                            resolve: {
                                message: function () {
                                    if ($scope.portal) {
                                        return "An error occurred submitting the form. Please try again. If you continue to experience problems, please contact your system administrator.\n" + ((response != null && response.error != null) ? response.error : "");
                                    }
                                    else {
                                        return "An error occurred submitting the form. Please try again. If you continue to experience problems, please submit a support ticket\n" + ((response != null && response.error != null) ? response.error : "");
                                    }
                                }
                            }
                        }).result.then(function (result) {
                            $scope.saving = false;
                        });
                    }
                });

                return deferred.promise;
            }

            var waitToFinish = function (loopCount) {
                // creating array of functions that return promises
                var promiseFuncs = [];
                for (var i = 1; i <= 30; i++) { // 30 iterations that should take between 30s-60s maximum
                    promiseFuncs.push(checkAdditionalFormsFactory());
                }
                // now we want to sequentially execute this array of promise factories
                executeSequentialPromiseFactories(promiseFuncs).then(function (result) {
                    // if we fall into this block the array has reached its max iterations and we will display a message on the first occurance and start the loop over again
                    if (loopCount == 1) {
                        $scope.response.form.submissionMessage = 'Your application is still submitting and there may be additional steps that require your attention. Please do not close this window. You will be redirected shortly.';
                    }

                    waitToFinish(loopCount + 1);
                }).catch(function (reject) {
                    // we have a number of reject reasons set up, in this case reject stops our polling and we make a decision based on the reject reason
                    $scope.saving = false;
                    if (reject == 'Charges') {
                        $state.go('portal.menus.checkout', { redirectImmediately: $scope.redirectImmediately });
                    }
                    else {
                        var newContinuePage = $rootScope.portal_pages["portal.menus.applicationsContinueList"];
                        if (newContinuePage != null && newContinuePage.visible) {
                            $state.go('portal.menus.applicationsContinueList');
                        } else {
                            $state.go('portal.menus.applications');
                        }
                    }
                });
            }

            $scope.handleSubmit = function () {
                Session.checkIn();
                $scope.loadingMessage = "Submitting application response...";
                $scope.redirectImmediately = false;
                $scope.submitting = true;
                $scope.saving = true;

                //If the PDF generation finishes before the submission redirect takes place, we need to know that it happened so we do not wait for a call that already happened.
                //In the scenario that a charge is added, we will redirect to the portal.menus.checkout page with a redirectImmediately parameter of true
                //The same code below here will watch for the 'reset:application' to be broadcast to the $rootscope as well as on the application-checkout.js
                $rootScope.$on('reset:application', function () {
                    $scope.redirectImmediately = true;
                });

                SignalR.onReceiveMessage(function (message) {
                    $scope.loadingMessage = message;
                });
                var connectionId = SignalR.getConnectionId();

                LicenseRequests.submit($scope.application, $scope.response, $scope.parameters, connectionId).then(function (result) {
                    if (result != null && result.success) {
                        if ($scope.portal) {
                            if ($scope.review) {
                                $scope.saving = false;
                                $scope.submitting = false;
                                $state.go('portal.menus.review');
                            }
                            else {
                                // going to poll the server until triggers are complete
                                LicenseRequests.getByID($scope.application.id).then(function (application) {
                                    // initialization
                                    $scope.application = application;

                                    $scope.lastApplication = $scope.application && $scope.application.responses && $scope.application.responses.every(function (response) {
                                        return (response.progress == 2); // if all other responses are done then we navigate to checkout
                                    });

                                    waitToFinish(1);
                                });
                            }
                            $scope.loadingMessage = "Completing Form...";
                        }
                        else {
                            $scope.loadingMessage = "Completing Form...";
                            if ($scope.getApplication != null) {
                                $scope.getApplication();
                            }
                            $scope.saving = false;
                            $scope.submitting = false;
                            $state.go('internal.licensing.application.responses', { id: $scope.applicationID });
                        }
                    }
                    else {
                        $scope.submitting = false;
                        $scope.saving = false;

                        if (result != null && result.validationError) {
                        // Server-side validation failed
                            $uibModal.open({
                                animation: true,
                                templateUrl: 'templates/alert-modal/alert-modal.html',
                                controller: 'AlertModalController',
                                resolve: {
                                    message: function () {
                                        return "Required information is missing. Please check over the form and make sure to supply all required information.";
                                    }
                                }
                            }).result.then(function (result) {

                            });
                        }
                        else {
                            // something errored in the .NET side
                            $uibModal.open({
                                animation: true,
                                templateUrl: 'templates/alert-modal/alert-modal.html',
                                controller: 'AlertModalController',
                                resolve: {
                                    message: function () {
                                        if ($scope.portal) {
                                            return "An error occurred submitting the form. Please try again. If you continue to experience problems, please contact your system administrator.\n" + ((result != null && result.error != null) ? result.error : "");
                                        }
                                        else {
                                            return "An error occurred submitting the form. Please try again. If you continue to experience problems, please submit a support ticket\n" + ((result != null && result.error != null) ? result.error : "");
                                        }
                                    }
                                }
                            }).result.then(function (result) {

                            });
                        }
                    }
                });
            }

            // the reason we are writing a function that returns a function that returns a promise (a factory function) is that promises immediately start executing when created (ie pushed onto an array),
            // and we want to control when the promise gets executed so we can implement sequential promises using Array.reduce on an array of functions that return promises.
            var checkAdditionalFormsFactory = function () {
                return function () {

                    var deferred = $q.defer(); // note we are using AngularJS promises that do not use the recommended implementation, and are a subset of Q
                    // timeout so we get at least 30s waiting, which may be more like 45s-60s due to round trip to server 
                    $timeout(function () {
                        // make a request to see if this is the last application and if triggers are firing
                        LicenseRequests.getByID($scope.application.id).then(function (application) {
                            $scope.application = angular.copy(application);

                            $scope.lastApplication = $scope.application && $scope.application.responses && $scope.application.responses.every(function (response) {
                                return (response.progress == 2);
                            });

                            // if this is the last application and no triggers are firing, then we are going to stop polling and decide what we are going to do, else continue polling
                            if (($scope.application.current_triggers_firing_count != null && $scope.application.current_triggers_firing_count > 0)) {
                                deferred.resolve('Triggers Still Firing');
                            }
                            else {
                                if ($scope.lastApplication && $scope.application.license.charges && $scope.application.checkout !== false) {
                                    // redirect to checkout only if there are charges on this license
                                    deferred.reject('Charges');
                                }
                                else if ($scope.lastApplication) {
                                    deferred.reject('No Charges')
                                }
                                else if (!$scope.lastApplication) {
                                    deferred.reject('Not Last Application')
                                }
                                else {
                                    deferred.reject('Unknown');
                                }
                            }
                        })
                            .catch(function (response) {
                                // handle error
                            });
                    }, 1000);
                    return deferred.promise;
                }
            }

            // helper function to execute promises sequentially
            var executeSequentialPromiseFactories = function (tasks) {
                var finalPromise = tasks.reduce(function (prev, current) {
                    return prev = prev.then(current);
                }, $q.when());
                return finalPromise;
            }

            $scope.submit = function () {
                $scope.submitFailed = false;
                $scope.loadingMessage = "Saving application response...";
                $scope.save(false, true).then(function (documentErrors) {
                    $scope.saving = true;
                    $scope.submitting = true;
                    if (documentErrors != null && documentErrors.length > 0) {
                        // Abandon submit if there were errors from saving documents
                        $scope.saving = false;
                        $scope.submitting = false;
                    }
                    else if ($scope.response.form.validationMessages != null && $scope.response.form.validationMessages !== undefined && $scope.response.form.validationMessages.length > 0) {
                        // Abandon submit if there are validation messages
                        $scope.saving = false;
                        $scope.submitting = false;
                    }
                    else if ($scope.response.form.display_submit_confirmation) {
                        $scope.saving = false;
                        $scope.submitting = false;

                        $uibModal.open({
                            animation: true,
                            templateUrl: 'templates/confirm/confirm.html',
                            controller: 'ConfirmModalController',
                            resolve: {
                                message: function () {
                                    return "Are you sure you want to submit this form? If you submit, you will not be able to make any changes.";
                                }
                            }
                        }).result.then(function (result) {
                            $scope.saving = true;
                            $scope.submitting = true;

                            if (result) {
                                $scope.handleSubmit();
                            }
                            else {
                                $scope.saving = false;
                            }
                            $scope.submitting = false;
                        })
                            .catch(function (error) {
                                // handle error  
                            });
                    }
                    else {
                        $scope.handleSubmit();
                        $scope.submitting = false;
                    }
                })
                    .catch(function (error) {
                        // handle error  
                    });
            }

            var cleanupStateChange = $scope.$on('$stateChangeStart', function (event) {
                if ($scope.saving) {
                    var answer = confirm("The application is currently submitting. Leaving this page could cause issues with your application. Are you sure you want to leave this page?");
                    if (!answer) {
                        event.preventDefault();
                    }
                    else {
                        window.onbeforeunload = null;
                    }
                }
                else {
                    window.onbeforeunload = null;
                }
            });

            window.onbeforeunload = function (e) {
                if ($scope.saving) {
                    var message = "The application is currently submitting. Leaving this page could cause issues with your application. Are you sure you want to leave this page?",
                        e = e || $window.event;
                    // For IE and Firefox
                    if (e) {
                        e.returnValue = message;
                    }

                    // For Safari
                    return message;
                }
            };

            $scope.$on('$destroy', function () {
                cleanupStateChange();
                $scope.timeouts.map(function (timeout) {
                    $timeout.cancel(timeout);
                });
            });
        }])
    .directive('applicationResponse', [function () {
        return {
            restrict: 'E',
            templateUrl: 'templates/application-response/application-response.html',
            replace: true,
            controller: 'ApplicationResponse'
        };
    }])
    ;